module.exports = __webpack_public_path__ + "img/logo_serco-300x150.136078fb.png";